import { Spinner as BaseSpinner } from "@/components/ui/spinner"

interface SpinnerProps {
  size?: number;
  color?: string;
}

/**
 * Compatibility wrapper — the canonical spinner is components/ui/spinner.tsx
 * (CVA + role="status" aria-label="Loading"). This preserves the numeric
 * `size` / `color` API used by existing tls callers while delegating the
 * implementation (and accessibility semantics) to the single canonical source.
 */
// §02.5: 20 is the default spinner size; callers pass 14 inside buttons.
export function Spinner({ size = 20, color = "var(--tls-fg-strong)" }: SpinnerProps) {
  return <BaseSpinner style={{ width: size, height: size, color }} />;
}
